import { render, staticRenderFns } from "./CoCheckboxSelection.vue?vue&type=template&id=6c84ffc7&"
import script from "./CoCheckboxSelection.vue?vue&type=script&lang=ts&"
export * from "./CoCheckboxSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports